import SMAllGames from "./SMAllGames";

export default SMAllGames;